import { isArray } from 'lodash'
import { useEffect, useState } from 'react'
import {
  getComparator,
  stableSort,
} from '../../Containers/City/Page/Ambasadors/Availabilities/components/AvailabilitiesTable/utils'

export const useSortData = ({
  order: initialOrder = 'desc',
  orderBy: initialOrderBy = '',
  data: initialData,
}) => {
  const [order, setOrder] = useState(initialOrder)
  const [orderBy, setOrderBy] = useState(initialOrderBy)
  const [data, setData] = useState(isArray(initialData) ? initialData : [])

  const onSort = property => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  useEffect(() => {
    if (order && orderBy && initialData) {
      const sortedData = stableSort(initialData, getComparator(order, orderBy))
      setData(sortedData)
    }
  }, [orderBy, order, initialData])

  return { onSort, data, order, orderBy }
}
